import * as storage from 'redux-persistence';
import { STORAGE_LOAD } from './actions';
export const INITIAL_STATE = {
    version: 1,
    loading: true
};
export function storageReducerWrapper(reducer, merger) {
    return storage.reducer(reducer, merger);
}
export function storageReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case STORAGE_LOAD:
            return {
                ...state,
                loading: false
            };
        default:
            return state;
    }
}
//# sourceMappingURL=reducer.js.map